// @flow

import type { Endpoints, EntityFieldCollection, SortParams, StoredEntityField } from '../types';
import { AscendingSortOrder, DescendingSortOrder } from '../types';

export const idField: StoredEntityField = {
    displayName: 'ID',
    recordName: 'id',
    dataType: {
        primitive: 'str',
        isArray: false,
        extraData: null,
    },
    supportsQuery: true,
    supportsSort: false,
    needToCreate: false,
    canEdit: false,
    isOptional: false,
    displayOnMain: true,
};

export const createdAtField: StoredEntityField = {
    displayName: 'Created At',
    recordName: 'created_at',
    dataType: {
        primitive: 'ts',
        isArray: false,
        extraData: null,
    },
    supportsQuery: true,
    supportsSort: true,
    needToCreate: false,
    canEdit: false,
    isOptional: false,
    displayOnMain: true,
};

export const paymentModeField: StoredEntityField = {
    displayName: 'Payment Mode',
    recordName: 'payment_mode',
    dataType: {
        primitive: 'enum',
        isArray: false,
        extraData: {
            1: 'Test',
            2: 'Mock',
            3: 'Real',
        },
    },
    supportsQuery: true,
    supportsSort: true,
    needToCreate: undefined,
    canEdit: undefined,
    isOptional: false,
    displayOnMain: false,
};

export const payfactoMerchantNoField: StoredEntityField = {
    displayName: 'Payfacto Merchant No',
    recordName: 'payfacto_merchant_no',
    dataType: {
        primitive: 'str',
        isArray: false,
        extraData: null,
    },
    supportsQuery: true,
    supportsSort: true,
    needToCreate: undefined,
    canEdit: undefined,
    isOptional: false,
    displayOnMain: false,
};

export function getCreatedAtSort(fieldName: string): SortParams {
    return {
        field: createdAtField,
        fieldName,
        order: DescendingSortOrder,
    };
}

export interface StoredEntity {
    fields: EntityFieldCollection; // static
    fileFields: EntityFieldCollection; // static
    defaultSort: SortParams; // static
    endpoints: Endpoints; // static
    constructor(record: any): StoredEntity; // static
    classInternalName: string; // static

    displayName: string;
    id: string;

    record: any;
}
